import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

class AuthState {
    public apiKey: string;
}


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public isAuthenticated = false;
    public $isAuthenticated: Observable<boolean>;
    private isAuthenticatedSubject: BehaviorSubject<boolean>;
    private authState: AuthState;

    constructor() {
        const authStateJson = sessionStorage.getItem('authState');

        if (authStateJson) {
            this.authState = JSON.parse(authStateJson);
            this.isAuthenticated = this.authState.apiKey != null;
        } else {
            this.authState = new AuthState();
        }

        this.isAuthenticatedSubject = new BehaviorSubject<boolean>( this.isAuthenticated );
        this.$isAuthenticated = this.isAuthenticatedSubject.asObservable();
    }

    public get apiKey(): string {
        return this.authState.apiKey;
    }

    public onSignIn(apiKey: string): void {
        this.authState.apiKey = apiKey;
        sessionStorage.setItem('authState', JSON.stringify(this.authState));
        this.isAuthenticated = true;
        this.isAuthenticatedSubject.next(true);
    }

    public onSignOut(): void {
        this.authState.apiKey = null;
        sessionStorage.removeItem('authState');
        this.isAuthenticated = false;
        this.isAuthenticatedSubject.next(false);
    }
}
